import { Link } from "react-router-dom";
import { Mail, Phone, MapPin, ArrowUpRight } from "lucide-react";
import { formations } from "@/data/formations";
import NewsletterForm from "@/components/Newsletter";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="bg-brand-ink text-white relative overflow-hidden" data-testid="site-footer">
      <div className="absolute inset-0 bg-grid-dark opacity-50 pointer-events-none" />
      <div className="relative max-w-7xl mx-auto px-5 md:px-8 pt-16 md:pt-20 pb-8">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-8">
          <div className="md:col-span-5">
            <Link to="/" className="inline-flex items-center gap-3 bg-white p-2" data-testid="footer-logo">
              <img src="/logo-yaformis.png" alt="YAFORMIS" className="h-20 w-auto" />
            </Link>
            <p className="mt-6 text-slate-400 max-w-md leading-relaxed">
              Organisme de formation professionnelle spécialisé en intelligence artificielle. Nous accompagnons entrepreneurs et salariés dans leur montée en compétences IA.
            </p>
            <div className="mt-6 flex flex-wrap gap-2">
              <span className="px-3 py-1 border border-white/20 text-xs font-semibold tracking-wide">Qualiopi · CERTIFOPAC</span>
              <span className="px-3 py-1 border border-white/20 text-xs font-semibold tracking-wide">Éligible CPF</span>
              <span className="px-3 py-1 border border-white/20 text-xs font-semibold tracking-wide">OPCO</span>
            </div>
            <NewsletterForm />
          </div>

          <div className="md:col-span-3">
            <div className="text-[10px] font-bold tracking-[0.2em] uppercase text-brand-blue mb-4">Formations</div>
            <ul className="space-y-2.5">
              {formations.map((f) => (
                <li key={f.slug}>
                  <Link
                    to={`/formations/${f.slug}`}
                    data-testid={`footer-formation-${f.slug}`}
                    className="text-slate-300 hover:text-white text-sm transition-colors"
                  >
                    {f.title}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-2">
            <div className="text-[10px] font-bold tracking-[0.2em] uppercase text-brand-blue mb-4">Navigation</div>
            <ul className="space-y-2.5">
              <li><Link to="/a-propos" className="text-slate-300 hover:text-white text-sm">À propos</Link></li>
              <li><Link to="/guide-ia" className="text-slate-300 hover:text-white text-sm">Guide IA</Link></li>
              <li><Link to="/blog" className="text-slate-300 hover:text-white text-sm">Blog</Link></li>
              <li><Link to="/contact" className="text-slate-300 hover:text-white text-sm">Contact</Link></li>
              <li><Link to="/mentions-legales" className="text-slate-300 hover:text-white text-sm">Mentions légales</Link></li>
              <li><Link to="/certificat-qualiopi" className="text-slate-300 hover:text-white text-sm" data-testid="footer-link-certificat">Certificat Qualiopi</Link></li>
              <li><Link to="/protection-donnees" className="text-slate-300 hover:text-white text-sm">Protection des données</Link></li>
            </ul>
          </div>

          <div className="md:col-span-2">
            <div className="text-[10px] font-bold tracking-[0.2em] uppercase text-brand-blue mb-4">Contact</div>
            <ul className="space-y-3 text-sm text-slate-300">
              <li className="flex items-start gap-2">
                <Mail className="w-4 h-4 mt-0.5 text-brand-blue shrink-0" />
                <a href="mailto:yaformis@gmail.com" className="hover:text-white" data-testid="footer-email">yaformis@gmail.com</a>
              </li>
              <li className="flex items-start gap-2">
                <Phone className="w-4 h-4 mt-0.5 text-brand-blue shrink-0" />
                <a href="tel:+33626345597" className="hover:text-white" data-testid="footer-phone">06 26 34 55 97</a>
              </li>
              <li className="flex items-start gap-2">
                <MapPin className="w-4 h-4 mt-0.5 text-brand-blue shrink-0" />
                <span>77 Bis rue Pierre Brossolette<br />95200 Sarcelles</span>
              </li>
            </ul>
            <Link
              to="/contact"
              data-testid="footer-cta-button"
              className="mt-5 inline-flex items-center gap-2 text-sm font-semibold text-brand-cta hover:translate-x-1 transition-transform"
            >
              Demander un devis <ArrowUpRight className="w-4 h-4" />
            </Link>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-white/10 flex flex-col md:flex-row md:items-center md:justify-between gap-3 text-xs text-slate-500">
          <div>
            © {year} YAFORMIS · SIRET 818 785 198 00065 · NDA 11 93 07706 93 · 77 Bis rue Pierre Brossolette, 95200 Sarcelles · Qualiopi CERTIFOPAC
          </div>
          <div className="flex gap-4">
            <Link to="/mentions-legales" className="hover:text-white">Mentions légales</Link>
            <span>·</span>
            <Link to="/contact" className="hover:text-white">Contact</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
